import axios from 'axios'
import { envVariables } from '../envVariables'
import {installAxiosRequestDeduper} from '../../../../utils/http/requestDeduper'
import {getAccessToken} from '../../../../utils/authSession'

const PromoApi = axios.create({
	baseURL: envVariables.apiUrl, // TODO create .env
	timeout: 100000,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': '*',
		'Access-Control-Allow-Credentials': true,
	},
	transformResponse: [
		function (data) {
			try {
				if (data) {
					const parsedData = JSON.parse(data)
					return parsedData.items ? parsedData.items : parsedData
				} else {
					return data
				}
			} catch (error) {
				throw Error(
					`[requestClient] Error parsingJSON data - ${JSON.stringify(error)}`
				)
			}
		},
	],
})

PromoApi.interceptors.request.use((config) => {
	const token = getAccessToken()
	if (token) config.headers.Authorization = `Bearer ${token}`

	return config
})

installAxiosRequestDeduper(PromoApi)

export default PromoApi
